import './webpack-public-path';
import './redirect';
import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
import { initFaro } from './services/faro.service';

initFaro();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
